import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'svg-scl-sprite',
  templateUrl: './svg-scl.component.html',
  styleUrls: ['./svg-scl.component.scss']
})
export class SvgSclComponent implements OnInit {
  data: any;
  constructor() { }

  ngOnInit() {
  }

}
